<template>
  <div class="coat">
    <!-- 头部 -->
    <div class="section">
      <p>大数据BI商业智能解决方案</p>
      <img src="../assets/product/1.png" alt="" />
    </div>
    <!-- 内容提示 -->
    <div class="tips">
      <div>
        <img src="../assets/product/icon.png" alt="" />
        <span>首页 >大数据BI商业智能解决方案</span>
      </div>
    </div>
    <!-- 整体内容 -->
    <div class="main">
      <div style="margin-bottom: 10px">方案概述</div>
      <p>
        随着业务规模的不断扩大，以及信息量爆发式的增长，对行内的数据应用模式已经提出了更高的要求，
      </p>
      <p>
        但是当前分析工具以Excel为主，数据大多数由手工汇总的技术现状，以满足这些要求。大数据BI是一
      </p>
      <p>
        种结合了商业智能和大数据技术的解决方案，能够帮助企业从大量数据中获取有价值的信息和洞察力，
      </p>
      <p>从而做出更明智的商业决策。</p>
      <div class="title">应用场景</div>
      <div class="box">
        <div class="sections">
          <div class="section-title">数据大屏</div>
          <div class="blackfont">
            理驾驶舱是一个为管理层提供的一站式决策支持的管理信息中心系统，
            它以虚拟驾驶舱的形式，用各种常见的图表形象展示企业运营的关键性能
            指标（KPI），直观地监测企业运营情况，并且可以对异常指标进行预警
            和分析
          </div>
        </div>
        <div class="sections">
          <div class="section-title">移动应用</div>
          <div class="blackfont">
            移动时代，无论工作还是生活，都离不开智能手机和移动应用。对于 BI
            项目来说，在移动端查看和分析数据是必不可少的一个需求。移动应用的
            落地，让管理者能及时发现问题，做出分析决策；让业务人员能即时进行
            业务分析和处理日常事务。
          </div>
        </div>
        <div class="sections">
          <div class="section-title">自助分析</div>
          <div class="blackfont">
            当前，商业智能（BI）的发展趋势正从IT主导的报表模式往业务主导的自
            助式分析模式演变，越来越多的企业和部门希望能够自己处理和分析数据
            ，减少数据建设到决策分析的时间。而且，这一转变的价值在企业中也得
            到验证，也就是说自助分析模式的确能够解放 IT 人员，赋能业务，提高效
            率。
          </div>
        </div>
      </div>
      <div class="title">整体架构</div>
      <div>
        <img
          style="width: 90%; margin: 10px 5%"
          src="../assets/product/BI1.png"
          alt=""
        />
      </div>
      <div class="title">方案优势</div>
      <div class="adv">
        <div class="mains">
          <img src="../assets/product/BI2.png" alt="" />
          <p class="font">全面直观的数据展示</p>
          <p class="content">
            多样可视化数据大屏以直观且易于理解的方式呈现
            各种类型的数据使用户能迅速掌握数据。
          </p>
        </div>
        <div class="mains">
          <img src="../assets/product/BI3.png" alt="" />
          <p class="font">灵活定制个性化配置</p>
          <p class="content">
            提供灵活的定制和配置，用户可以根据自己的
            需求和喜好调整布局、选择指标、设置报警等
            功能，以打造适合自己工作场景的数据展示平 台。
          </p>
        </div>
        <div class="mains">
          <img src="../assets/product/BI4.png" alt="" />
          <p class="font">数据安全与隐私保护</p>
          <p class="content">
            具备严格的数据安全措施，确保数据在传输
            和存储过程中的安全性。支持用户权限管理
            确保只有授权人员才能查看和操作相关数据。
          </p>
        </div>
      </div>

      <div class="title">相关资料</div>
      <div class="flex">
        <img
          style="width: 250px; height: 300px; margin-right: 20px"
          src="../assets/product/BI5.png"
          alt=""
        />
        <div style="width: 30%; text-align: left">
          <p class="flex-title">《雅格BI产品宣传册》</p>
          <p class="flex-font">
            BI通过利用数据分析技术来帮助企业做出更明智决策的工具和
            流程。通过收集、整理、分析企业内部和外部的数据，BI能够
            将大量数据转化为有用的信息，帮助企业管理层了解业务运营
            状况、识别趋势和模式，并制定有效的业务战略。
          </p>
          <div class="flex-button" @click="downLoad()">立即下载</div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  // import axios from "axios";
export default {
  name: "",
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    downLoad(){
      let pdfUrl = 'https://oss.zijingshuke.com/1724305437762.pdf' 
      fetch(pdfUrl)
        .then((response) => response.blob())
        .then((blob) => {
          var ua = window.navigator.userAgent.toLowerCase();
          if (ua.indexOf("micromessenger") > -1) {
            return true; // 是微信端
          } else {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = decodeURIComponent('BI宣传册'.split("/").pop());
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            return false;
          }
        })
        .catch((error) => {
          console.error(error);
        });
      // axios
      //   .get("/download?fileCode=BI", {
      //     responseType: "blob", // 设置响应类型为blob
      //   })
      //   .then((response) => {
      //     console.log(response.data)
      //     // 假设后端返回的文件数据流存储在response中
      //     let blob = new Blob([response.data], { type: "application/pdf" });

      //     let url = window.URL.createObjectURL(blob);
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", "BI宣传册.pdf"); // 设置下载文件的文件名为filename.pdf
      //     document.body.appendChild(link);
      //     link.click();
      //     window.URL.revokeObjectURL(url);
      //   })
      //   .catch((error) => {
      //     console.error("Error fetching file data:", error);
      //   });
    }
  },
};
</script>
  <style scoped lang="scss">
.coat {
  width: 100%;

  .section {
    margin: 0 0 -5px;
    position: relative;
    color: #ffffff;
    cursor: pointer;
    background: #187be0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10%;
    img {
      width: 240px;
      height: auto;
    }
    p {
      font-weight: bold;
      font-size: 30px;
      color: #f3f6f9;
    }
  }
  // 内容提示
  .tips {
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    div {
      margin-left: 12%;
      img {
        width: 12px;
        height: 12px;
        vertical-align: middle;
      }
      span {
        font-size: 10px;
        color: #808080;
        margin: 0 6px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  // 整体内容
  .main {
    width: 100%;
    background: #f5f5fa;
    text-align: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #405c80;
    padding: 60px 0;
    box-sizing: border-box;
    font-size: 28px;
    cursor: pointer;
    .title {
      margin: 60px auto;
    }
    .box {
      display: flex;
      width: 90%;
      margin: 10px 5%;
      justify-content: space-around;
      .sections {
        width: 30%;
        background-image: url("../assets/home/bg.png");
        padding: 25px 10px;
        box-sizing: border-box;
        .section-title {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 30px;
          color: #090909;
          margin: 10px auto;
        }
        .redfont {
          font-weight: bold;
          font-size: 14px;
          color: #ff0505;
          text-align: left;
        }
        .blackfont {
          font-weight: bold;
          font-size: 14px;
          color: #090909;
          text-align: left;
          margin: 25px auto 10px;
        }
      }
    }
    .adv {
      display: flex;
      justify-content: space-between;
      width: 90%;
      margin: 10px 5%;
      .mains {
        width: 32%;
        img {
          width: 100px;
        }
        .font {
          font-weight: bold;
          font-size: 30px;
          color: #000000;
          margin: 10px auto;
        }
        .content {
          font-size: 15px;
          color: #000000;
          text-align: left;
        }
      }
    }
    .flex {
      display: flex;
      justify-content: center;
      img {
        width: 30%;
        margin: 0 10px;
      }
      .flex-title {
        font-weight: bold;
        font-size: 30px;
        color: #405680;
      }
      .flex-font {
        font-weight: bold;
        font-size: 18px;
        color: #405680;
        margin: 40px auto 20px;
        text-align: left;
      }
      .flex-button {
        width: 100px;
        height: 35px;
        background: #1473eb;
        border-radius: 3px;
        text-align: center;
        line-height: 35px;
        font-weight: bold;
        font-size: 18px;
        color: #f1f4f8;
      }
    }
    p {
      color: #8d9bb9;
      font-size: 20px;
    }
    img {
      width: 55%;
      height: auto;
    }
  }
}
</style>
  